import React from "react";
import { App, View } from 'framework7-react';
import routes from "./routes";
import {store} from "./store/index";
import {Provider} from "react-redux";
import { I18nextProvider } from 'react-i18next';
import i18n from "./modules/i18n/i18n";
const MyApp = () => {
    return (
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <App
                    routes={routes}
                    view={{ browserHistory: true, browserHistorySeparator: '' }}
                    name="Betstack"
                    theme="auto"
                    popup={{ closeOnEscape: true }}
                    sheet={{ closeOnEscape: true }}
                    popover={{ closeOnEscape: true }}
                    actions={{ closeOnEscape: true }}
                >
                    <View name="main" main url="/" />
                </App>
            </I18nextProvider>
        </Provider>
    );
};

export default MyApp;
